export default "__VITE_ASSET__CDNHg06K__"